import { render, staticRenderFns } from "./TwoFactorQRStep.vue?vue&type=template&id=7490f459"
import script from "./TwoFactorQRStep.vue?vue&type=script&lang=js"
export * from "./TwoFactorQRStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports